import { MessageCircle, Phone, ArrowRight } from "lucide-react";
import { trackContact } from "../../lib/metaPixel";

export default function DedicatedCTA({
  title = "Ready to elevate your business?",
  subtitle = "Discuss your growth goals directly with our strategic team in Navi Mumbai. No generic sales pressure.",
  source = "service_page",
}) {
  return (
    <section className="bg-navy py-20 md:py-28 text-white relative overflow-hidden">
      <div className="absolute -left-20 top-1/2 h-80 w-80 -translate-y-1/2 rounded-full bg-[#FF5722]/10 blur-3xl pointer-events-none" />
      <div className="relative mx-auto max-w-5xl px-5 text-center sm:px-8">
        <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-[#FF5722] backdrop-blur-sm mb-6">
          <span className="h-2 w-2 rounded-full bg-[#FF5722]" />
          <span>Strategic Partnership</span>
        </div>

        <h2 className="font-display text-3xl font-black uppercase leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
        </h2>
        <p className="mx-auto mt-6 max-w-2xl font-body text-base leading-relaxed text-white/70 sm:text-lg">
          {subtitle}
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href="/#contact"
            className="inline-flex items-center gap-2 rounded-full bg-[#FF5722] px-8 py-4 font-display text-sm font-bold uppercase tracking-wider text-white transition hover:bg-[#E64A19] shadow-lg shadow-[#FF5722]/30"
          >
            Book Free Growth Consultation <ArrowRight size={16} />
          </a>
          <a
            href="https://wa.me/919322106632"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackContact("whatsapp", { location: "dedicated_cta", label: "Chat on WhatsApp" })}
            className="inline-flex items-center gap-2 rounded-full border border-emerald-500/60 bg-emerald-500/10 px-7 py-4 font-display text-sm font-bold uppercase tracking-wider text-emerald-300 transition hover:bg-emerald-500 hover:text-white"
          >
            <MessageCircle size={18} /> Chat on WhatsApp
          </a>
          <a
            href="tel:+919322106632"
            onClick={() => trackContact("phone", { location: "dedicated_cta", label: "Call +91 93221 06632" })}
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-4 font-display text-sm font-bold uppercase tracking-wider text-white transition hover:border-white hover:bg-white/10"
          >
            <Phone size={16} /> +91 93221 06632
          </a>
        </div>
      </div>
    </section>
  );
}
